import React from 'react'
import { connect } from 'react-redux'
import IntroPage from './IntroPage'
import AboutMePage from './AboutMePage'
import TimeLine from './TimeLine'
import JobDescriptionBox from './JobDescriptionBox'
import ProjectsLayout from './ProjectsLayout'
import BarChart from './BarChart'
import ContactPage from './ContactPage'
import SlidingMenu from './SlidingMenu'
import Carousel from './Carousel'

class App extends React.Component{
  constructor(props){
    super(props)
  }

  // render(){
  //   return(
  //     <div className="container">
  //     <Carousel data={this.props.carousel.data}/>
  //     </div>
  //   )
  // }


  render(){
    return(
      <div>  
        <SlidingMenu />
        <Carousel carouselId="pysaass-carousel" data={this.props.carousel.data}/>

        {/* Cover */}
        <IntroPage />
        
        {/* About */}
        <div className="divider"></div>
          <AboutMePage />
        <div className="divider"></div>

        {/* Projects */}
        <div className="container">
          <div className="row">
            <h3 id="projects" className="section-header center-align"> Projects </h3>
          </div>
          <ProjectsLayout projectsData={this.props.work.projects} />
        </div>

        <div className="divider"></div>

        {/* Tutorials */}
        <div className="container">
          <div className="row">
            <h3 id="tutorials" className="section-header center-align"> Blogs &amp; Tutorials </h3>
          </div>
          <ProjectsLayout projectsData={this.props.work.tutorials} />
        </div>
      
        <div className="divider"></div>

        {/* Resume Timeline */}
        <div className="row">
          <h3 id="resume" className="section-header center-align">My Resume Timeline</h3>
        </div>

        <div className="row">
          <div className="col s12 center-align">
            <a href="./assets/docs/resume.pdf" target="_blank">PDF Version</a>
          </div>
        </div>

        <div className="row">
          <div id="timeline-container" className="col s12 l6">
            <TimeLine />
          </div>
          <div id="description-box-container" className="col l6 description-box hide-on-med-and-down">
            <JobDescriptionBox />
          </div>
        </div>

        <div className="divider"></div>

        {/* Technologies */}
        <div className="container">
          <div id="barchart-container" className="row">
            <h3 id="technologies" className="section-header center-align">Technologies</h3>
          </div>
          <BarChart chartData={this.props.technical.experience} />
        </div>

        {/* Contact Footer */}
        <ContactPage />
      </div>
    )
  }
}

function mapStateToProps(state){
  return {work:state.ProjectsReducer, technical:state.ExperienceReducer, carousel:state.CarouselReducer}
}

export default connect(mapStateToProps, null)(App)


// TODO: Add screenshots to pysass woth carousele
// TODO: Add descriptions to BSc and MSc
// TODO: Find new fonts


// WEBPACK FOOTER //
// ./app/components/App.js